function initBookingButton(element) {
    element.addEventListener('click', function (e) {
        e.preventDefault();

        let configuration = JSON.parse(this.getAttribute('data-booking-configuration'));
        configuration.iframeId = 'booxi-iframe-' + Date.now().toString(36) + Math.random().toString(36).substr(2);
        configuration.googleTag = function () {
            window.dataLayer.push(arguments);
        }
        configuration.googleTagEventFormat = 'GA4';
        BookNow.open(configuration);
    })
}

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-booking-configuration]').forEach(function (element) {
        initBookingButton(element);
    })
})

var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length >= 1) {
            for (var i = 0; i < mutation.addedNodes.length; i++) {
                if (undefined !== mutation.addedNodes[i].localName) {
                    mutation.addedNodes[i].querySelectorAll('[data-booking-configuration]').forEach(function (element) {
                        initBookingButton(element);
                    })
                }
            }
        }
    });
});

observer.observe(document.body, { attributes: false, childList: true, characterData: false, subtree: true });